import React, { useState, useEffect } from 'react';
import { Form, Checkbox, Select, message, Alert } from 'antd';
import axiosRequest from '@/api';
import { ResData } from '@/@types';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { PartnerCompany } from '@/@types/PartnerCompany';
import * as S from './index.styled';

const { Option } = Select;

interface DelegateConsentProps {
  isAgreed: boolean;
  handleAgreementChange: (e: CheckboxChangeEvent) => void;
  category: string;
  partnerId: string | null;
  setPartnerId: (id: string) => void;
  errorMessage: string;
  setErrorMessage: (message: string) => void;
}

const DelegateConsent: React.FC<DelegateConsentProps> = ({
  isAgreed,
  handleAgreementChange,
  category,
  partnerId,
  setPartnerId,
  errorMessage,
  setErrorMessage,
}) => {
  const [upperAdvertisers, setUpperAdvertisers] = useState<PartnerCompany[]>([]);

  useEffect(() => {
    const fetchUpperAdvertisers = async () => {
      try {
        const response = await axiosRequest.requestAxios<ResData<PartnerCompany[]>>(
          'get',
          `/partner_company/${category}`,
        );
        const advertisers = response.data.map(advertiser => ({
          ...advertiser,
          key: advertiser.id.toString(),
        }));
        setUpperAdvertisers(advertisers);
      } catch (error) {
        message.error('상위 대행사 정보를 가져오는 데 실패했습니다.');
      }
    };

    fetchUpperAdvertisers();
  }, [category]);

  const handleSelectChange = (value: string) => {
    setPartnerId(value);
    setErrorMessage(''); // 선택 시 에러 메시지 초기화
  };

  return (
    <S.Container>
      <S.Title>위임동의 페이지</S.Title>
      <S.AgreementSection>
        <S.BorderBox>
          <S.Label>대행사 </S.Label>
          <S.StyledSelect
            onChange={handleSelectChange}
            value={partnerId || undefined}
            placeholder="선택해주세요."
          >
            {upperAdvertisers.map(advertiser => (
              <Option key={advertiser.id} value={advertiser.id.toString()}>
                {advertiser.name}
              </Option>
            ))}
          </S.StyledSelect>
        </S.BorderBox>
      </S.AgreementSection>
      <S.CheckboxWrapper>
        <Checkbox checked={isAgreed} onChange={handleAgreementChange}>
          [필수] 대행사 위임 약관 동의
        </Checkbox>
      </S.CheckboxWrapper>
      {/* <S.TextareaWrapper>
          <textarea readOnly />
        </S.TextareaWrapper> */}
    </S.Container>
  );
};

export default DelegateConsent;
